<!--
================================================
View qui gère la l'user impersonation.

Une url renvoyée depuis le backend redirige vers cette page, celle-ci utilise alors les infos passées dans l'url pour simuler une authentification et stocker les informations nécéssaires dans la classe $auth.

voir /documentation/Impersonation.md

⚠️⚠️⚠️ CE FICHIER DOIT ÊTRE MIS À JOUR EN SELON LES CHANGEMENTS EFFECTUÉS
DANS LE BACKEND DANS SecurityController->manualImpersonation()
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <outdoor-layout-comp>

    <div slot="AppContent">
            <div class="columns">
                <div class="column">

                    <!-- titre de la page ----------------------------------------------->
                    <div class="has-text-left appTitle">
                        <h3 class="recapLine">Demande d'impersonation pour  <b class="user">{{targetUser}}</b> </h3>

                        <p class="warning">⚠️ Il est recommandé de se <router-link v-bind:to="{name:'logout'}" id="linkLogout" target= '_blank'> déconnecter </router-link> de la pwa avant de continuer.</p>

                       <div class="dataVerif">
                            <h4>User datas :</h4>
                           <div id="userOrganization" class="data">
                               <span class="key">organization : </span> <span class="value">{{organization}}</span>
                           </div>

                           <div id="userSlug" class="data">
                               <span class="key">slug : </span> <span class="value">{{userSlug}}</span>
                           </div>

                           <div id="userRoles" class="data">
                               <span class="key">roles : </span> <span class="value">{{roles}}</span>
                           </div>

                           <div id="userLocale" class="data">
                               <span class="key">locale : </span> <span class="value">{{locale}}</span>
                           </div>


                         <div id="activeWorkspace" class="data">
                           <span class="key">activeWorkspace : </span> <span class="value">{{activeWorkspace}}</span>
                         </div>

                       </div>


                        <a class="revealLink" v-on:click="toggleVisibility()"> > reveal token</a>

                        <div class="tokenContainer">

                            <div class="reveal" v-show="tokenVisibility">
                                    <div class="token">
                                        {{token}}
                                    </div>
                            </div>

                        </div>
                        <br>

                        <a v-on:click="impersonate()" target="_blank" id="impersonateBtn" class="button is-link">{{$t('continuer')}}</a> |
                        <router-link v-bind:to="{name:'logout'}" id="appMenuLinkLogout">
                            <font-awesome-icon class="icon"  :icon="['fas', 'power-off']" />
                            {{ $t("Déconnexion") }}
                        </router-link>
                    </div>


                </div>
            </div>

        </div>
        </outdoor-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import OutdoorLayoutComp from '@/components/OutdoorLayoutComp.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import GlobalErrorNotificationMixin from "../mixins/GlobalErrorNotificationMixin.js";
    import InitialHydrationMixin from "../mixins/InitialHydrationMixin.js";
    import SpinnerLoaderComp from '@/components/SpinnerLoaderComp.vue';
    import {mapState} from "vuex";


    export default {
        name: 'ImpersonateView',
        data: function () {
            return {
                tokenVisibility: false, // si le token est visible dans le .reveal
                componentIsReady : false, // indique quand le composant est prêt à être afficher
                // =================================================================
            }
        },
        computed:{
            // computed props for store :
            ...mapState({
                currentPeriod: state => state.ReportView.currentPeriod
            }),

            //----------------------------------------------
            // other computed props :

            targetUser: { // le user à impersonate
                get: function () {return this.$route.params.targetUser},
            },
            organization: { // organization de l'user
                get: function () {return this.$route.params.organization},
            }
            ,userSlug: { // le slug de l'user à impersonate
                get: function () {return this.$route.params.userSlug},
            }
            ,token: { // le token du user à impersonate
                get: function () {return this.$route.params.token},
            }
            ,roles: { // Array de roles l'utilisateur
                get: function () {
                    return  this.$route.params.roles.split(',')
                }
            }
            ,locale: { // locale de l'utilisateur
                get: function () {
                    return this.$route.params.locale
                }
            },
            workspaces:{ // slugs des workspaces dans lesquels l'user est membre
              get: function () {
                return  this.$route.params.workspaces.split(',')
              }
            }
            ,activeWorkspace: { // workspace actuel de l'utilisateur
              get: function () {
                return this.$route.params.activeWorkspace
              }
            }

            ,activeWorkspaceCurrency: { // currency du workspace actuel
            get: function () {
              return this.$route.params.activeWorkspaceCurrency
            }
          }


          //----------------------------------------------


        },

        components: {
            OutdoorLayoutComp,
            SpinnerLoaderComp
        },
        mixins: [VueMetaMixin, SentryMixin, InterceptorMixin, GlobalErrorNotificationMixin, InitialHydrationMixin],
        //==========================================================
        metaInfo(){
            return this.setMeta('User Impersonation',this.$t("metaDescDefault"))
        },
        //==========================================================
        methods: {

            /*
            * Déclenche l'user impersonation
            */
            impersonate:function () {

                this.$auth
                    .setToken(this.token)
                    // .setRefreshToken(response.data.refresh_token) // Pas possible d'inclure le refresh token pour le moment
                    .setOrganization(this.organization)
                    .setRoles(this.roles)
                    .setUserSlug(this.userSlug)
                    .setImpInProgress(true)
                    .setWorkspaces(this.workspaces)
                    .setActiveWorkspace(this.activeWorkspace) // @todo à dynamiser lors de ticket #290 (https://gitlab.com/ousmane1/kronocloud/-/issues/290)
                    .setActiveWorkspaceCurrency(this.activeWorkspaceCurrency) // @todo voir si à dynamiser lors de ticket #290
                    .saveCookie();

                // on récup. et stocke l' user l'organization dans le store
                this.userInitialHydration(this)

                //redirection vers page de login -> qui le redirigera car on est connecté
                this.$router.replace({name: 'login',params:  {'locale':this.$route.params.locale}})

            }

            ,toggleVisibility: function () {
                if(this.tokenVisibility){
                    this.tokenVisibility = false
                }
                else{
                    this.tokenVisibility = true
                }
            },

        },
        created: function () {
        },
        mounted: function () {
        }
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";

    .columns{
        background: rgba(255, 255, 255, 0.91);
        border: solid 1px #ccc;
        padding: 1rem;
        overflow: hidden;

        .user{
            color:$brandBlue;
        }

        .warning {
            margin: 0.5rem 0;
            padding: 0.5rem;
            border: dashed 1px darken($brandYellow, 15%);
            background: $brandYellow;
            color: darken($brandYellow, 50%);
            /*font-weight: bold;*/
            & a {
                text-decoration: underline;
            }
        }
        .revealLink{
            color: #999;
            font-weight: bold;
            margin: 0.5rem auto;
            display: block;
        }
    }

    .dataVerif{
        margin: 1rem 0;
        .key{font-weight: bold;}
        .value{ font-family: Courier Next, courier, monospace; color:$brandBlue}
    }

    .tokenContainer{
        /*margin: 1rem auto;*/
        overflow: auto;


        .reveal{
            display: inline-block;
            background:#333;
            font-family: Courier Next, courier, monospace;
            border: solid 1px $brandBlue;
            font-style: italic;
            color: #999;
            padding: 1rem;
            border-radius: 0.2rem;
            overflow-y: scroll;
            width: 70%;

        }
    }

</style>
